import React from "react";
import "../scss/about.scss";
import Heading from "../components/Heading";

const About = () => {
  return (
    <section id="about" className="about">
      <Heading id="aboutHeading" number="01" text="About Me" />
      <div className="about_content">
        <p>
          I currently create, design, update and maintain advanced web pages and
          portals both on the server side (Back-end) and on the client side
          (Front-end, UX/UI).
        </p>
        <p>
          I am continuously learning and acquiring new skills based on current
          and future demands and technological trends in the field of design and
          development of web applications in general.
        </p>
        <p>
          Passionate about the work I do, i offer total attention, dedication,
          personalization and quality to the client in each project.
        </p>
      </div>
    </section>
  );
};

export default About;
